import { Badge } from "@/components/ui/badge";

const STAGE_STYLES: Record<string, string> = {
  tof: "bg-sky-100 text-sky-800",
  mof: "bg-violet-100 text-violet-800",
  bof: "bg-emerald-100 text-emerald-800",
};

export function NarrativeFunnelStageBadge({ stage }: { stage: string | null | undefined }) {
  const normalized = stage?.trim().toLowerCase();
  if (!normalized || !STAGE_STYLES[normalized]) return null;

  return (
    <Badge
      data-testid="narrative-funnel-stage"
      className={`text-[9px] rounded-full px-2 py-0 ${STAGE_STYLES[normalized]}`}
    >
      {normalized.toUpperCase()}
    </Badge>
  );
}